import { RecurrenceType } from "@clockwise/schema";

export const getRecurranceEnum = (obj: { recurrenceType: RecurrenceType | null }) =>
  obj.recurrenceType;

export default getRecurranceEnum;
